var _Icon, _Icon2;

import React from 'react';
import classnames from 'classnames';
import Icon from "../../../Common/Icon";
import { Text } from "../../../Typography";
import styles from './ModalHeader.scss';

var ModalHeader = function ModalHeader(_ref) {
  var onCancel = _ref.onCancel,
      title = _ref.title,
      cancelButton = _ref.cancelButton;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement("header", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onCancel,
    className: classnames(styles.button, styles.arrow)
  }, _Icon || (_Icon = /*#__PURE__*/React.createElement(Icon, {
    name: "caret-right",
    color: "text"
  }))), /*#__PURE__*/React.createElement(Text, null, title), /*#__PURE__*/React.createElement("div", {
    className: styles.cancel
  }, cancelButton || /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onCancel,
    className: styles.button
  }, _Icon2 || (_Icon2 = /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    color: "text"
  }))))));
};

export default ModalHeader;